import React from 'react'
import Contact from '../../components/contact/Contact'

function index() {
  return (
    <>
      <Contact />
    </>
  )
}

export default index